export function slideChange(
  sliderEl: HTMLDivElement,
  context: string,
  slideTo?: number
) {
  const onNextClick = () => {
    if (sliderEl !== null) {
      const imgWidth = sliderEl.offsetWidth;
      sliderEl.scrollLeft += imgWidth;

      const sliderFullWidth = sliderEl.scrollWidth;
      const lastSlide = sliderFullWidth - imgWidth;
      if (lastSlide == Math.round(sliderEl.scrollLeft)) {
        sliderEl.scrollLeft = 0;
      }
    }
  };

  const onPreviousClick = () => {
    const imgWidth = sliderEl.offsetWidth;
    sliderEl.scrollLeft -= imgWidth;
  };

  const changeToSlide = () => {
    const targetElement = document
      .querySelector(`[data-id="${slideTo}"]`)
      .getBoundingClientRect();

    sliderEl.scrollLeft += targetElement.left;
  };

  switch (context) {
    case "next":
      onNextClick();
      break;
    case "previous":
      onPreviousClick();
      break;
    case "slideTo":
      changeToSlide();
      break;
    default:
      break;
  }
}
